import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import Paragraphs from "../Texts/Paragraphs";

ChartJS.register(ArcElement, Tooltip, Legend)

const DoughnutChart = ({ data = [] }) => {
  // Data for the chart
  const chartData = {
    labels: data.map((item) => item.title),
    datasets: [
      {
        data: data.map((item) => item.amount),
        backgroundColor: data.map((item) => item.color),
        borderColor: data.map((item) => item.color),
        borderWidth: 0,
        // borderAlign: "inner",
        // offset: 5
        spacing: 10
      },
    ],
  }


  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const { width, height, ctx } = chart;
      ctx.restore();
      const fontSize = (height / 250).toFixed(2);

      ctx.font = `${fontSize}em text-[12px] font-Apparat font-[700]`;
      ctx.fillStyle = "#42495280";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";


      const textLabel = "Total";
      const textX = width / 2;
      const textY = height / 2.2 - 10;

      ctx.fillText(textLabel, textX, textY);
      // const totalValue = data?.reduce((acc, item) => acc + item.amount, 0);
      // Calculate total from chart data (to ensure reactivity)
      const totalValue = chart.config.data.datasets[0].data.reduce((acc, value) => acc + Number(value), 0);

      // Format the total with commas
      const formattedTotalValue = totalValue.toLocaleString();
      console.log("dataaaaa....", chart.config.data.datasets[0]);
      console.log("total walveee", totalValue);
      // Text for the total value
      const textValue = formattedTotalValue ? `Rs ${formattedTotalValue}` : "";
      const valueY = height / 2 + 10;

      ctx.font = `bold ${fontSize}em sans-serif font-[700]`;
      ctx.fillStyle = "#000000";
      ctx.fillText(textValue, textX, valueY);

      ctx.save();
    },
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allow adjusting aspect ratio
    plugins: {
      legend: {
        display: false, // hide the legend
      },
    },
  };

  return (
    <div className="grid grid-cols-3 md:grid-cols-2 h-full">
      <div className="col-span-2 md:col-span-2 w-[100%] h-full rounded-full flex justify-center">
        <Doughnut data={chartData} options={options}
          plugins={[centerTextPlugin]}
        />
      </div>
      <div className="col-span-1 md:col-span-2 w-[100%]   flex justify-center flex-col md:flex-row  ml-[15px] md:ml-[0px] md:mt-[15px]   flex-wrap">
        <div className="flex flex-col md:flex-row bg-white  px-[15px] md:px-[20px]  lg:px-[30px] py-[15px] md:py-[15px] rounded-[12px] gap-[25px] md:gap-[18px]">
          {data?.map((item, index) => (
            <div
              key={index}
              className={`flex justify-between   ${index !== 0 ? "" : ""}`}
            >
              <div className="flex flex-col justify-between  items-start">
                <Paragraphs
                  variant="tertiary"
                  className=" text-[#42495280]"
                  text={item?.title}
                />
                <span className="flex flex-row items-center mt-[0px] md:mt-[14px]">
                  <div
                    className={`w-[16px] h-[16px] md:w-[20px] md:h-[20px] 
                      lg:w-[26px] lg:h-[26px] rounded-[5px]`}
                    style={{ backgroundColor: item?.color }}
                  />
                  <Paragraphs
                    text={`${item?.value}%`}
                    variant="tertiary"
                    className="ml-[8px]"
                  />

                </span>
                <p className="font-Apparat font-[600] md:mt-[16px] text-nowrap text-[12px] md:text-[24px] leading-[28.8px]">
                  {"\u20B9"} {item?.amount}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}

export default DoughnutChart
